<template>
  <div>
    <user-list-add-new
        :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
        :form-config="formConfig"
        :default-create-object="createDefault"
        @refetch-data="refetchData"
    />

    <users-list-filters v-if="showFilter"
                        :form-config="formConfig"
    />
    <b-card
        no-body
        class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">

              <b-form-input v-if="formConfig.searchName !==null"
                            v-model="searchQuery"
                            class="d-inline-block mr-1"
                            placeholder="Search..."/>

              <template v-if="formConfig.functionButtons !=null" v-for="action in formConfig.functionButtons ">
                <b-button
                    variant="primary"
                    style="margin: 0px 1px"
                    @click="actionWithButton(action)"
                >
                  <span class="text-nowrap">{{ action.text }}</span>
                </b-button>

              </template>
              <b-button
                  v-if="formConfig.deleteBtn"
                  variant="primary"
                  style="margin: 0px 1px"
                  @click="deleteAction"
              >
                <span class="text-nowrap">Delete</span>
              </b-button>

              <b-button v-if="formConfig.addBtn"
                        variant="primary"
                        style="margin: 0px 1px"
                        @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Add {{ formConfig.entity }}</span>
              </b-button>


            </div>
          </b-col>
        </b-row>

      </div>
      <!--      ref="selectableTable"-->
      <!--      selectable-->
      <!--      :select-mode="selectMode"-->
      <!--      :items="items"-->
      <!--      :fields="fields"-->
      <!--      responsive-->
      <!--      class="mb-0"-->
      <b-table
          ref="tableData"
          class="position-relative"
          :items="fetchData"
          responsive
          selectable
          :fields="tableColumns"
          primary-key="id"
          select-mode="multi"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
          @row-selected="onRowSelected"


      >
        <template v-for="conf in images" v-slot:[gomycell(conf)]="data">
          <b-img :src="data.item[conf]" fluid="true"></b-img>
        </template>
        <!-- Column: Actions -->
        <template v-if="formConfig.editBtn" #cell(id)="data">

          <b-media v-if="formConfig.actions == null || (formConfig.actions !=null && formConfig.actions.length == 1)"
                   vertical-align="center">
            <b-link v-if="formConfig.actions == null"
                    :to="{ name: `apps-${formConfig.entity}`, params: { id: data.item.id } }"
                    class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.id }}
            </b-link>
            <b-link v-if="formConfig.actions != null"
                    :to="{ name: formConfig.actions[0].action, params:formConfig.actions[0].generateRouterParam(data.item.id) }"
                    class="font-weight-bold d-block text-nowrap"
            >
              # {{ data.item.id }}
            </b-link>
          </b-media>


          <b-dropdown v-if="formConfig.actions !=null && formConfig.actions.length > 1" class="cell-id"
                      variant="link"
                      no-caret
                      toggle-class="p-0"


          >
            <template #button-content>
              #{{ data.item.id }}
            </template>


            <template v-if="formConfig.actions !=null" v-for="action in formConfig.actions ">
              <b-dropdown-item :to="{ name: action.action, params:  action.generateRouterParam(data.item.id)}">
                <feather-icon icon="FileTextIcon"/>
                <span class="align-middle ml-50"> {{ action.text }}</span>
              </b-dropdown-item>
            </template>

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
                dataMeta.of
              }} entries</span>
          </b-col>
          <!-- Pagination -->

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BImg,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {onUnmounted, ref} from '@vue/composition-api'
import {avatarText} from '@core/utils/filter'
import UsersListFilters from './UsersListFilters.vue'
import useUsersList from './useUsersList'
import userStore from './storeModule'
import UserListAddNew from './UserListAddNew.vue'
import {FormConfig, FieldType} from '../common/index.d.ts'

//import {FormConfig, PropertyConfig, FieldType, Filter, Operator} from "./index.d.ts";
import axios from '@axios'
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Image from "@/views/components/image/Image";


export default {
  components: {
    BImg,
    UsersListFilters,
    UserListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },


  props: {


    formConfig: {
      type: FormConfig,
      required: true,
    },
  },

  // methods: {
  //
  // },

  setup(props) {
    const toast = useToast()
    let createDefault = ref({});
    let selected = [];
    const formConfig = props.formConfig
    const configs = formConfig.configs;
    let images = []
    formConfig.configs.forEach(f => {
      if (f.type === FieldType.CK_IMAGE) {
        images.push(f.name)
      }
    });


    console.log(configs);

    const USER_APP_STORE_MODULE_NAME = `app-${formConfig.entity}`
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      const us = userStore(formConfig);
      // console.log(`==register store == in moudle ${USER_APP_STORE_MODULE_NAME}`);
      // console.log(us);
      store.registerModule(USER_APP_STORE_MODULE_NAME, us)
      onUnmounted(() => {
        if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      })
      console.log(`register ${USER_APP_STORE_MODULE_NAME}`)

    } else {
      console.log(`already register ${USER_APP_STORE_MODULE_NAME}`)
    }

    const onRowSelected = (items) => {
      selected = items
      console.log(selected)
    };

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      tableData,

    } = useUsersList(formConfig)

    const openAddNew = () => {
      isAddNewUserSidebarActive.value = true
    }


    const actionWithButton = (button) => {
      let ids = selected.map(f => f.id);
      let body = {
        ids: ids
      }
      axios
          .put(button.action, body)
          .then(response => {
            refetchData()
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: button.successMsg,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {

          })
    }
    let urlEntity = _.snakeCase(formConfig.entity)
    let processError = (error) => {
      try {
        if (error.response.data) {
          toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: error.response.data.error.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        }
      } catch (e) {
        toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: "process failed",
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      }
    }

    const deleteAction = () => {
      let ids = selected.map(f => f.id);
      let query = ids.join(",")

      axios
          .delete(`${urlEntity}?ids=${query}`)
          .then(response => {
            refetchData()
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: 'Delete successfully',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            processError(error);
          })
    }

    let gomycell = (config) => {
      return `cell(${config})`;
    };
    const showFilter = formConfig.filters != undefined && formConfig.filters != null && formConfig.filters.filter((f) => f.type != FieldType.HIDE).length > 0;
    const res = {
      showFilter,
      gomycell,
      FieldType,
      configs,
      images,
      onRowSelected,
      createDefault,
      isAddNewUserSidebarActive,
      fetchData,
      deleteAction,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      tableData,
      avatarText,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      actionWithButton,
      openAddNew,
    }


    if (formConfig.filters) {
      formConfig.filters.forEach(filter => {
        res[`${filter.name}Filter`] = filter.value;
      })
    }

    return res
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}


</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
